module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_IS-790805dccb9928b34b72a3d5ec4edc40.svg";